import env from '@/constants/env';

const { company } = env;

export const isGoal = () => {
  return company.id === 'k-goal';
};
export const isGood = () => {
  return company.id === 'k-good';
};

export const hideFee = (studentId, assignData) => {
  if (!isGoal()) {
    return false;
  }

  // Check if the plan is "建替払い" (replacement payment)
  // Use assignData from /assign/{student_id}/{teacher_id} API
  if (assignData) {
    return assignData.plan === '建替払い';
  }

  // If assignData is not provided, assume the plan information
  // is not available and show the fee
  return false;
};
